import { ElementRef } from '@angular/core';

const supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;

export function getBannerHeight(): number {
  const nav = document.querySelector<HTMLElement>('nav');
  return nav ? nav.offsetHeight : 0;
}

export function scrollTo(element: HTMLElement): void {
  const navHeight = getBannerHeight();
  const posY = element.getBoundingClientRect().top + window.scrollY - navHeight;
  window.scrollTo({
    top: posY,
    behavior: 'smooth',
  });
}

export function scrollToOffset(offset: number, smooth?: boolean): void {
  if (smooth && supportsNativeSmoothScroll) {
    window.scrollTo({ top: offset, behavior: 'smooth' });
  } else {
    window.scrollTo({ top: offset });
  }
}

export function scrollToTop(smooth = true, defer = true): void {
  const doScroll = () => {
    const scroller = document.scrollingElement || document.documentElement;
    if (smooth && 'scrollBehavior' in document.documentElement.style) {
      scroller.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      scroller.scrollTop = 0;
    }
  };

  if (defer) {
    requestAnimationFrame(() => {
      requestAnimationFrame(doScroll);
    });
  } else {
    doScroll();
  }
}

export const smoothScroll = (
  y: number,
  useBannerOffset = true,
  mainScrollContainer: HTMLElement = document.body,
): void => {
  const yWithHeaderOffset = useBannerOffset ? y - getBannerHeight() : y;
  if (supportsNativeSmoothScroll) {
    mainScrollContainer.scrollTo({ top: yWithHeaderOffset, left: 0, behavior: 'smooth' });
  } else {
    mainScrollContainer.scrollTop = yWithHeaderOffset;
  }
};

export const smoothScrollTo = (element: HTMLElement, mainScrollContainer: HTMLElement = document.body): void => {
  const y = element.offsetTop;
  smoothScroll(y, true, mainScrollContainer);
};

export function openAbove(elementRef: ElementRef<unknown>): boolean {
  const element = elementRef.nativeElement as HTMLElement;
  const rect = element.getBoundingClientRect();
  const middleOfElement = rect.top + (rect.bottom - rect.top) / 2;
  const screenHeight = window.innerHeight;
  return middleOfElement > screenHeight / 2;
}
